import styled from 'styled-components'

export default styled.div`
  background-color: ${({ theme }) => theme.colors.tertiary};
  height: 1px;
  margin: 0 auto 1px;
  width: 100%;
`
